import React from 'react'

import styled from '@emotion/styled'
import { mq, text } from '../../../_style';
import Text from '../../atoms/text';
import Image from '../../atoms/image';

const Container = styled.div`
  ${mq.pc} {
    display: flex;
    justify-content: space-between;
  }
  & + & {
    margin-top: 69px;
    ${mq.sp} {
      margin-top: 34px;
    }
  }
`
const Inner = styled.div`
`
export default class DetailFeatureItem extends React.Component {
  render() {
    return(
      <Container>
        <Inner>{this.props.children}</Inner>
      </Container>
    )
  }
}
